import { useKeycloak } from '@josempgon/vue-keycloak'
import AuthService from '../services/auth.service'

const user = JSON.parse(sessionStorage.getItem('user'))
const initialState = user ? { status: { loggedIn: true }, user } : { status: { loggedIn: false }, user: null }

export const authModule = {
  namespaced: true,

  state: initialState,

  actions: {
    async login ({ commit }, user) {
      return AuthService.login(user).then(
        response => {
          const user = response.data
          commit('loginSucess', user)
          sessionStorage.setItem('user', JSON.stringify(response.data))
          return Promise.resolve(user)
        },
        error => {
          commit('loginFailure')
          return Promise.reject(error)
        }
      )
    },

    async logout ({ commit }) {
      return AuthService.logout().then(
        response => {
          sessionStorage.removeItem('user')
          commit('logoutSuccess')
          return Promise.resolve(response)
        },
        error => {
          return Promise.reject(error)
        }
      )
    },

    async reinitSelfPwd ({ commit }, criterias) {
      return AuthService.reinitSelfPwd(criterias).then(
        response => {
          const userResponse = response.data
          return Promise.resolve(userResponse)
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },
  },

  mutations: {
    loginSucess (state, user) {
      state.status.loggedIn = true
      state.user = user
    },
    loginFailure (state) {
      state.status.loggedIn = false
      state.user = null
    },
    logoutSuccess (state) {
      state.status.loggedIn = false
      state.user = null
    }
  }
}
